module.exports = __webpack_public_path__ + "static/img/number_reco.cdb0fb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/prj/number_reco.png
// module id = e3Pz
// module chunks = 1